var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.basicInfo)?_c('footer',[_c('FooterInfo',{attrs:{"basicInfo":_vm.basicInfo}}),_c('FooterNav',{attrs:{"facebookLink":_vm.basicInfo.facebookLink,"thumbtackLink":_vm.basicInfo.thumbtackLink,"logoLarge":_vm.basicInfo.logoLarge,"logoSmall":_vm.basicInfo.logoSmall,"thumbtackLogo":_vm.basicInfo.thumbtackLogo}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }